module.exports = __webpack_public_path__ + "img/muros_de_ladrillo.9c64929d.png";